import React, { useState, useMemo, useEffect } from "react";
import Api from "../../services/Api";
import { useResponsive } from "../../hooks/useResponsive";

const PAGE_SIZE = 10;

export default function UsuariosModal({ isOpen, onClose }) {
  const { isDesktop } = useResponsive();
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);

  useEffect(() => {
    if (isOpen) {
      Api.getUsers().then((d) => setData(d));
    }
  }, [isOpen]);

  const totalPages = Math.ceil((data.length || 0) / PAGE_SIZE);

  const currentData = useMemo(() => {
    const start = (currentPage - 1) * PAGE_SIZE;
    return data.slice(start, start + PAGE_SIZE);
  }, [data, currentPage]);

  if (!isOpen) return null;

  // Recebe o índice global diretamente
  const toggleAtivo = (globalIndex) => {
    setData((prev) => {
      const updated = [...prev];
      updated[globalIndex] = {
        ...updated[globalIndex],
        is_active: !updated[globalIndex].is_active,
      };
      return updated;
    });
  };

  const handleSave = () => {
    Api.changeUsersStatus(data).then(() => {
      alert("Status dos usuários atualizado com sucesso!");
    });
  };

  const Toggle = ({ active, onToggle }) => (
    <div
      onClick={(e) => { e.stopPropagation(); onToggle(); }}
      style={{
        width: 40,
        height: 20,
        borderRadius: 20,
        background: active ? "#F2A66C" : "#ccc",
        position: "relative",
        cursor: "pointer",
        transition: "background 0.25s ease",
        flexShrink: 0,
      }}
    >
      <div
        style={{
          width: 16,
          height: 16,
          background: "#fff",
          borderRadius: "50%",
          position: "absolute",
          top: 2,
          left: 2,
          transition: "transform 0.25s ease",
          transform: active ? "translateX(18px)" : "translateX(0)",
          boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
        }}
      />
    </div>
  );

  return (
    <div style={overlay}>
      <div style={modal}>

        {/* HEADER */}
        <div style={header}>
          <h3 style={{ margin: 0, fontSize: 15, fontFamily: "'DM Sans', sans-serif" }}>
            Usuários — {data.length}
          </h3>
          <button onClick={onClose} style={closeButton}>✕</button>
        </div>

        {/* CONTEÚDO */}
        <div style={{ flex: 1, overflow: "auto" }}>
          {isDesktop ? (
            /* ── TABELA (desktop) ── */
            <div className="table-scroll-x">
              <table style={table}>
                <thead>
                  <tr>
                    <th style={{ ...th, width: "25%" }}>Usuário</th>
                    <th style={{ ...th, width: "35%" }}>Nome</th>
                    <th style={{ ...th, width: "35%" }}>Email</th>
                    <th style={{ ...th, width: "5%", textAlign: "center" }}>Ativo</th>
                  </tr>
                </thead>
                <tbody>
                  {currentData.map((user, localIndex) => {
                    const globalIndex = (currentPage - 1) * PAGE_SIZE + localIndex;
                    return (
                      <tr
                        key={globalIndex}
                        style={{
                          background: localIndex % 2 === 0 ? "rgba(242,166,108,0.1)" : "#fff",
                        }}
                      >
                        <td style={td}>{truncate(user.username, 30)}</td>
                        <td style={td}>{truncate(user.name, 75)}</td>
                        <td style={td}>{truncate(user.email, 100)}</td>
                        <td style={{ ...td, textAlign: "center" }}>
                          <Toggle
                            active={user.is_active}
                            onToggle={() => toggleAtivo(globalIndex)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            /* ── CARDS (mobile / tablet) — sem paginação ── */
            <div style={{ padding: "8px 0" }}>
              {data.map((user, globalIndex) => (
                <div
                  key={globalIndex}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 12,
                    padding: "14px 16px",
                    borderBottom: "1px solid #f0ebe6",
                    background: globalIndex % 2 === 0 ? "rgba(242,166,108,0.04)" : "#fff",
                  }}
                >
                  {/* Informações */}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div
                      style={{
                        fontFamily: "'DM Sans', sans-serif",
                        fontWeight: 700,
                        fontSize: 14,
                        color: "#2d2d2d",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {user.name}
                    </div>
                    <div
                      style={{
                        fontFamily: "'DM Sans', sans-serif",
                        fontSize: 12,
                        color: "#888",
                        marginTop: 2,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      @{user.username}
                    </div>
                    <div
                      style={{
                        fontFamily: "'DM Sans', sans-serif",
                        fontSize: 12,
                        color: "#bbb",
                        marginTop: 2,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {user.email}
                    </div>
                  </div>

                  {/* Toggle */}
                  <Toggle
                    active={user.is_active}
                    onToggle={() => toggleAtivo(globalIndex)}
                  />
                </div>
              ))}
            </div>
          )}
        </div>

        {/* FOOTER */}
        <div style={footer}>
          {/* Paginação — só no desktop */}
          {isDesktop && (
            <>
              <button
                onClick={() => setCurrentPage((p) => p - 1)}
                disabled={currentPage === 1}
                style={navButton}
              >
                ◀
              </button>
              <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: "#666" }}>
                {currentPage} / {totalPages}
              </span>
              <button
                onClick={() => setCurrentPage((p) => p + 1)}
                disabled={currentPage === totalPages}
                style={navButton}
              >
                ▶
              </button>
            </>
          )}

          <button onClick={handleSave} style={saveButton}>
            Salvar Alterações
          </button>
        </div>
      </div>
    </div>
  );
}

function truncate(text, max) {
  if (!text) return "";
  return text.length > max ? text.substring(0, max) + "..." : text;
}

/* ── ESTILOS ── */

const overlay = {
  position: "fixed",
  top: 0, left: 0,
  width: "100%", height: "100%",
  background: "rgba(0,0,0,0.45)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
};

const modal = {
  width: "min(95vw, 650px)",
  maxHeight: "90vh",
  background: "#fff",
  borderRadius: "14px",
  overflow: "hidden",
  boxShadow: "0 16px 48px rgba(0,0,0,0.22)",
  display: "flex",
  flexDirection: "column",
};

const header = {
  background: "linear-gradient(135deg, #F2A66C 0%, #E8956A 100%)",
  padding: "14px 20px",
  color: "#fff",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

const closeButton = {
  background: "transparent",
  border: "none",
  color: "#fff",
  fontSize: "20px",
  cursor: "pointer",
  lineHeight: 1,
  padding: "0 4px",
};

const table = {
  width: "100%",
  borderCollapse: "collapse",
};

const th = {
  padding: "10px 12px",
  textAlign: "left",
  background: "#f5f5f5",
  fontFamily: "'DM Sans', sans-serif",
  fontSize: 13,
  fontWeight: 600,
  color: "#666",
};

const td = {
  padding: "10px 12px",
  fontSize: "14px",
  fontFamily: "'DM Sans', sans-serif",
  color: "#444",
};

const footer = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "10px 16px",
  borderTop: "1px solid #f0f0f0",
  gap: 8,
};

const navButton = {
  background: "none",
  border: "1px solid #ddd",
  borderRadius: 6,
  padding: "6px 12px",
  cursor: "pointer",
  fontFamily: "'DM Sans', sans-serif",
  fontSize: 13,
  color: "#555",
};

const saveButton = {
  marginLeft: "auto",
  background: "#E8956A",
  border: "none",
  padding: "8px 16px",
  color: "#fff",
  borderRadius: "8px",
  cursor: "pointer",
  fontFamily: "'DM Sans', sans-serif",
  fontWeight: 600,
  fontSize: 14,
};
